import React from "react";

// TODO: This whole component could be rewritten!

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    const children = React.Children.toArray(this.props.children);

    // This enables opening the tab for a specific sensor.
    // TODO: maybe refactor this to deviceconfigwindow?
    let { showSensor } = this.props;
    let activeTab = children[0].props.label;

    if (showSensor) {
      let sensorKey = showSensor;
      // Filter children to find sensorconfigpane, that corresponds to sensorKey
      let childrenForSensor = children.filter(child => {
        return parseInt(child.props.sensorKey) === parseInt(sensorKey);
      });
      if (childrenForSensor && childrenForSensor.length > 0) {
        activeTab = childrenForSensor[0].props.label;
      }
    }
    this.state = {
      activeTab
    };
  }

  componentDidUpdate(prevProps) {
    // accepts switchtotab

    const children = React.Children.toArray(this.props.children);
    const prevChildren = React.Children.toArray(prevProps.children);

    if (this.props.showSensor) {
      if (
        this.props.showSensor === "last" &&
        children.length !== prevChildren.length
      ) {
        let lastChild = children[children.length - 1];
        if (lastChild) {
          this.setState({ activeTab: lastChild.props.label });
        }
      }

      if (this.props.showSensor !== prevProps.showSensor) {
        // "last" is a special value showSensor can take, which causes to select the last child (tab)

        let childrenForSensor = children.filter(child => {
          if (child && child.props && child.props.hasOwnProperty("sensorKey")) {
            return (
              parseInt(child.props.sensorKey) === parseInt(this.props.showSensor)
            );
          }
          return undefined
        });
        if (childrenForSensor && childrenForSensor.length > 0) {
          this.setState({ activeTab: childrenForSensor[0].props.label });
        }
      }
    }
  }

  onClickTabItem = tab => {
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      onClickTabItem,
      props: { children },
      state: { activeTab }
    } = this;
    return (
      <div className="tabs ">
        <div className="tabbar configpane-tabbar">
          {React.Children.map(children, child => {
            const { label, alias, buttonAction } = child.props;
            // If there is a button action prop, dont show content, just dispatch the action
            return (
              <Tab
                activeTab={activeTab}
                key={label}
                label={label}
                alias={alias}
                onClick={buttonAction || onClickTabItem}
                isButton={!!buttonAction}
              />
            );
          })}
        </div>
        <div className="tabcontent">
          {React.Children.map(children, child => {
            if (child.props.label === activeTab) {
              return child.props.children;
            }
          })}
        </div>
      </div>
    );
  }
}

export default Tabs;

class Tab extends React.Component {
  render() {
    const { label, alias, onClick, activeTab, isButton } = this.props;
    let isActive = label === activeTab;
    let cssClass = "tab configpane-tab";
    cssClass += isActive ? " active" : "";
    cssClass += isButton ? " button" : "";
    return (
      <div
        className={cssClass}
        onClick={() => {
          onClick(label);
        }}
      >
        <div className="configpane-tab-label">{label}</div>
        <div className="configpane-tab-alias">{alias}</div>
      </div>
    );
  }
}
